var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirebase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#151521"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 27.982L20.7875 32.7695C20.225 33.0768 19.6625 33.0768 19.1 32.7695L11 27.982L25.6812 12.4376L26.075 12.3194C26.4125 12.3194 26.6037 12.4731 26.6375 12.7922L29 27.982ZM17.0188 12.674L11.9 21.5988L14.0375 7.47283C14.0712 7.15367 14.2625 7 14.6 7C14.825 7 14.9712 7.07093 15.05 7.29552L17.4688 11.9648L17.0188 12.674ZM22.0813 14.1634L11.3375 25.4997L19.4938 10.96C19.6062 10.7236 19.775 10.6172 20 10.6172C20.225 10.6172 20.3712 10.7236 20.45 10.96L22.0813 14.1634Z",
    fill: "#151521"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/firebase.395b7ed59a2deacc50561298c7db7022.svg";
export { ForwardRef as ReactComponent };